import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNativescriptComponent } from './simple-icons-nativescript.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNativescriptComponent ],
    exports:      [ SimpleIconsNativescriptComponent ],
    bootstrap:    []
})
export class SimpleIconsNativescriptModule {}
